export class LocalStorageUtility {
  static removeLocalStorage = () => {
    localStorage.removeItem('inputValues');
    localStorage.removeItem('contractValues');
    localStorage.removeItem('digSafeValues');
    localStorage.removeItem('searchValues');
    localStorage.removeItem('jobBriefValues');
    localStorage.removeItem('unmarkedutilitiesValues');
    localStorage.removeItem('userValues');
    localStorage.removeItem('roleValues');
    localStorage.removeItem('vendorValues');
    localStorage.removeItem('employeeGroupsValues');
    localStorage.removeItem('preJobVideoValues');
    localStorage.removeItem('inputValuesTimeCardSpecial');
    localStorage.removeItem('inputValuesMaterialIssue');
    localStorage.removeItem('inputValuesElectroFusion');
    localStorage.removeItem('fuserQcFormValues');
    localStorage.removeItem('masterFusingDatabaseValues');
    localStorage.removeItem('cmsFusionQCFormsValues');
    localStorage.removeItem('equipmentDatabaseValues');
    localStorage.removeItem('equipmentManagementValues');
    localStorage.removeItem('fiftyThirteenValues');
    localStorage.removeItem('fiftyThirteenInputs');
    localStorage.removeItem('poTracker:inputs');
    localStorage.removeItem('poTrackerValues');
    localStorage.removeItem('airTestValues');
  };
}
